module.exports = __webpack_public_path__ + "img/wiperx_banner.ab930a26.jpg";